import { render } from "./AdminDestinations.vue?vue&type=template&id=2960575e"
import script from "./AdminDestinations.vue?vue&type=script&lang=js"
export * from "./AdminDestinations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__